module.exports = __webpack_public_path__ + "img/agencyReseller.924f8b49.jpg";